"use strict";
exports.__esModule = true;
exports.Offset = void 0;
var Offset = /** @class */ (function () {
    function Offset() {
    }
    Offset.get = function (element) {
        if (!element) {
            return;
        }
        if (!element.getClientRects().length) {
            return { top: 0, left: 0 };
        }
        var rect = element.getBoundingClientRect();
        var win = element.ownerDocument.defaultView;
        return {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        };
    };
    return Offset;
}());
exports.Offset = Offset;
